import BaseService from './BaseService';

export default class BillingService extends BaseService {
  fetchPlan = async () => {
    const r = await this.client.get('/plans');

    return await r.json();
  };

  fetchInvoices = async (period: {
    startTimestamp: number;
    endTimestamp: number;
    limit: number;
    page: number;
  }) => {
    const r = await this.client.post('/billing/invoices', {
      startTimestamp: Math.round(period.startTimestamp / 1000),
      endTimestamp: Math.round(period.endTimestamp / 1000),
      limit: period.limit,
      page: period.page,
    });

    return await r.json();
  };

  upgradePlan = async (instance: any) => {
    const r = await this.client.post(`/plans/billing`, instance);

    return await r.json();
  };

  updatePlan = async (instance: any) => {
    const r = await this.client.put(`/plans/edit`, instance);

    return await r.json();
  };

  cancelPlan = async () => {
    const r = await this.client.delete(`/plans/cancel`);

    return await r.json();
  };

  enablePlan = async () => {
    const r = await this.client.get(`/plans/re-enable`);

    return await r.json();
  };

  getOnboard = async () => {
    const r = await this.client.get(`/boarding`);

    return await r.json();
  };

  changeCaptureLimit = async (limit: number) => {
    const r = await this.client.post('/plans/sessions', { sessions: limit });

    return await r.json();
  };
}
